import { v4 as uid } from 'uuid';

import type { GuidedItem } from 'src/types/appState';

const defaultState: GuidedItem[] = [];

const ADD_ITEM = 'formData/responsibilities/ADD';
const ADD_MULTIPLE_ITEMS = 'formData/responsibilities/ADD_MULTIPLE_ITEMS';
const EDIT_ITEM = 'formData/responsibilities/EDIT';
const FILTER_INVALID_ITEMS = 'formData/responsibilities/FILTER_INVALID_ITEMS';
const ON_BLUR_ITEM = 'formData/responsibilities/ON_BLUR_ITEM';
const ON_FOCUS_ITEM = 'formData/responsibilities/ON_FOCUS_ITEM';
const REMOVE_ITEM = 'formData/responsibilities/REMOVE';
const RESET = 'formData/qualifications/RESET';

const add = () => ({
  type: ADD_ITEM,
});

const addMultipleItems = (items: string[]) => ({
  type: ADD_MULTIPLE_ITEMS,
  items,
});

const edit = (id: string, value: string) => ({
  type: EDIT_ITEM,
  id,
  value,
});

const filterInvalidItems = () => ({
  type: FILTER_INVALID_ITEMS,
});

const onBlur = (id: string) => ({
  type: ON_BLUR_ITEM,
  id,
});

const onFocus = (id: string) => ({
  type: ON_FOCUS_ITEM,
  id,
});

const remove = (id: string) => ({
  type: REMOVE_ITEM,
  id,
});

const reset = () => ({
  type: RESET,
});

export const actions = {
  add,
  addMultipleItems,
  edit,
  filterInvalidItems,
  onBlur,
  onFocus,
  remove,
  reset,
};

export default (state = defaultState, action: any) => {
  switch (action.type) {
    case ADD_ITEM: {
      return [
        ...state,
        {
          id: uid(),
          isEditing: true,
          value: '',
        },
      ];
    }

    case ADD_MULTIPLE_ITEMS: {
      return action.items.map((item: string[]) => ({
        id: uid(),
        isEditing: false,
        value: item,
      }));
    }

    case EDIT_ITEM: {
      return state.map((item: GuidedItem) => {
        if (item.id === action.id) {
          return {
            ...item,
            value: action.value,
          };
        }
        return item;
      });
    }

    case FILTER_INVALID_ITEMS: {
      return state.filter((item: GuidedItem) => Boolean(item.value));
    }

    case ON_BLUR_ITEM: {
      return state.map((item: GuidedItem) => {
        if (item.id === action.id) {
          return {
            ...item,
            isEditing: false,
          };
        }
        return item;
      });
    }

    case ON_FOCUS_ITEM: {
      return state.map((item: GuidedItem) => {
        if (item.id === action.id) {
          return {
            ...item,
            isEditing: true,
          };
        }
        return item;
      });
    }

    case REMOVE_ITEM: {
      return state.filter((item: GuidedItem) => item.id !== action.id);
    }

    case RESET: {
      return defaultState;
    }

    default: {
      return state;
    }
  }
};
